export default __webpack_public_path__ + "static/media/expand-button.d4562d8e.svg";